import styled from '@emotion/styled'
import { AnimatePresence, motion } from 'framer-motion'
import React, { memo } from 'react'
import { useInView } from 'react-intersection-observer'

export interface Props {
  className?: string
  children: any
  counter?: any
  delay?: number
  direction?: 'top' | 'bottom'
  duration?: number
  onClick?: any
  onKeyDown?: any
}

export const AnimatedImage = memo(function AnimatedImage({
  className,
  children,
  delay,
  direction = 'top',
  counter,
  duration = 1,
  onClick,
  onKeyDown,
}: Props) {
  const [ref, isVisible] = useInView({
    triggerOnce: true,
  })

  const variants = {
    visible: {
      clipPath: 'inset(0)',
      transition: {
        delay,
        duration,
      },
    },
    hidden: {
      clipPath: direction === 'top' ? 'inset(0 0 100% 0)' : 'inset(100% 0 0)',
    },
  }

  return (
    <AnimatePresence mode="wait">
      <Container
        animate={isVisible ? 'visible' : 'hidden'}
        className={className}
        data-counter={counter}
        initial="hidden"
        onClick={onClick}
        onKeyDown={onKeyDown}
        ref={ref}
        role={onClick ? 'button' : undefined}
        tabIndex={onClick ? 0 : undefined}
        variants={variants}
      >
        {children}
      </Container>
    </AnimatePresence>
  )
})

const Container = styled(motion.div)`
  overflow: hidden;
  will-change: transform;
`
